/* eslint-disable */
import React, { useRef, useState } from 'react'
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { EditPageHeader } from '../../components/EditPageHeader';
import { Checkbox } from "@progress/kendo-react-inputs";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, SUBSCRIPTION_HISTORY_EVENT, SUBSCRIPTION_STATUS, TOAST_TYPES } from "../../framework/constant/constant";
import { useEffect } from 'react';
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import moment from 'moment';
import { DateCell, DateOnlyCell, DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { Switch } from '@mui/material';
import MyStatusCell from '../../components/MyStatusCell';
import BossDialog from '../../components/BossDialog';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import { SubscriberProfileEditForm } from './SubscriberProfileEditForm';
import ToastNotification from "../../components/ToastNotification";

const SubscriberEditForm = (props) => {

    const { item = {}, cancelEdit, refresh } = props;
    const lang = useTranslation();
    const currentDate = moment(new Date()).format('YYYY-MM-DD');

    const [segments, setSegments] = useState([]);
    const [regions, setRegions] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [historyData, setHistoryData] = useState([]);
    const [loginHistoryData, setLoginHistoryData] = useState([]);
    const [showPackageCollection, setShowPackageCollection] = useState(false);
    const [tabNumber, setTabNumber] = useState("1");
    const emailRegex = new RegExp(/\S+@\S+\.\S+/);
    const [showPackageStartDatePopup, setShowPackageStartDatePopup] = useState(false);
    const [packageData, setPackageData] = useState({
        StartDate: currentDate
    });
    const [removedPlans, setRemovedPlans] = useState([]);
    const [devicesData, setDevicesData] = useState([])
    const [currencys, setCurrencys] = useState([])
    const [showSubscriberProfileForm, setShowSubscriberProfileForm] = useState(false);
    const [profileData, setProfileData] = useState([])
    const [deleteItemsProfile, setdeleteItemsProfile] = useState([]);
    const selectedItemRef = useRef(0);
    const setSelectedItemRef = (data) => {
        selectedItemRef.current = data;
    }

    const blankDataItem = {
        SubscriptionID: item.SubscriptionID ?? '',
        Name: item?.copy ? "Copy of " + item.Name : item.Name ?? '',
        RMN: item?.RMN ?? '',
        Email: item.Email ?? '',
        PaymentPlan: item.PaymentPlan ?? [],
        LastUpdated: item.LastUpdated ?? (new Date()).getTime(),
        Region: item.Region ?? {},
        Segments: item.Segments ?? [],
        AutoRenew: item.AutoRenew ?? false,
        Archive: item.Archive ?? false,
        EnableParentalControl: item?.EnableParentalControl ?? false,
        Currency: item?.Currency ?? {},
        Profiles: item?.Profiles ?? []
    }

    useEffect(() => {
        pageRender();
    }, []);

    const pageRender = async () => {
        await loadcombo();
        if (item.SID > 0) {
            await loadEditData();
        }
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [showCoupon, setShowCoupon] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    const loadcombo = async () => {
        const regionRes = await API.getDataLookup(ENTITYNAME.Region, { query: ["Archive", '=', false], sort: { Description: 1 } });
        setRegions(regionRes.data);

        const segmentsRes = await API.getDataLookup(ENTITYNAME.OttSegment, { query: ["Archive", '=', false], sort: { Description: 1 } });
        setSegments(segmentsRes.data);

        const currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { query: ["Archive", "=", false], sort: { Description: 1 } });
        setCurrencys(currencyRes.data);
    }

    const loadEditData = async () => {

        let linkData = {
            link_collection: 'coupon',
            link_field: 'Coupons',
        }
        const res = await API.getEntity(ENTITYNAME.Subscriber, parseInt(item.SID), linkData);

        if (res.success) {
            let data = {
                ...dataItem,
                ...res.data,
                PaymentPlan: item.PaymentPlan
            }
            setHistoryData(data?.History ?? []);
            setLoginHistoryData(data?.LoginHistory ?? []);
            setDataItem(data);
            setGridData(data?.Coupons ?? []);
            setDevicesData(data?.loggedInDevice ?? []);
            setProfileData(data?.Profiles ?? [])
        }
    }


    const onChange = (e) => {
        if (e.target.name === "AutoRenew") {
            setDataItem({ ...dataItem, AutoRenew: !dataItem.AutoRenew });
        } else if (e.target.name === "EnableParentalControl") {
            setDataItem({ ...dataItem, EnableParentalControl: !dataItem.EnableParentalControl })
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (dataItem.SubscriptionID == "" || dataItem.SubscriptionID == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_subscription_id_error_message}` });
            return false;
        }
        if (dataItem.Name == "" || dataItem.Name == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_name_error_message}` });
            return false;
        }
        if (dataItem.RMN == "" || dataItem.RMN == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_rmn_error_message}` });
            return false;
        }
        if (dataItem.Email == "" || dataItem.Email == undefined || !emailRegex.test(dataItem.Email)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_email_error_message}` });
            return false;
        }
        if (dataItem.Region == undefined || Object.keys(dataItem.Region).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_region_error_message })
            return false
        }
        // if (dataItem.PaymentPlan.length == 0) {
        //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Select Payment Plan` });
        //     return false;
        // }
        return true;

    }

    const handleSubmit = async () => {

        if (!isValid()) return;

        let profileDataRes = (profileData && profileData.length > 0) ? profileData.map(x => { delete x.index; return x }) : [];
        let saveData = {
            _id: dataItem?._id,
            SID: dataItem.SID,
            SubscriptionID: dataItem.SubscriptionID,
            Name: dataItem.Name,
            RMN: dataItem.RMN,
            Email: dataItem.Email,
            Segments: dataItem.Segments?.length > 0 ? dataItem.Segments.map((x) => {
                return {
                    _id: x._id,
                    SID: x.SID,
                    Description: x.Description
                }
            }) : [],
            Region: (dataItem.Region && Object.keys(dataItem?.Region).length > 0) ? {
                _id: dataItem.Region._id,
                Description: dataItem.Region.Description
            } : {},
            Coupons: (gridData && gridData?.length > 0) ? gridData?.map(x => x._id) : [],
            Archive: dataItem.Archive ?? false,
            loggedInDevice: devicesData,
            EnableParentalControl: dataItem?.EnableParentalControl ?? false,
            Currency: (dataItem?.Currency && Object.keys(dataItem?.Currency).length > 0) ? {
                _id: dataItem?.Currency?._id,
                Description: dataItem?.Currency?.Description,
                Symbol: dataItem?.Currency?.Symbol
            } : {},
            Profiles: profileDataRes,
            checkDuplicate: true,
            query: [["RMN", "=", dataItem.RMN]]
        }

        if (item.SID > 0) {
            saveData._id = item._id
        }

        if (removedPlans.length > 0) {
            removedPlans.forEach((removedPlan) => {
                dataItem.PaymentPlan = dataItem.PaymentPlan.filter((x) => x._id !== removedPlan._id);
            });
            saveData.PaymentPlan = dataItem.PaymentPlan;
        }

        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.Subscriber, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.SUBSCRIBER, data: res.data, message: res.message };
            API.SaveLogs(logData);

            if (removedPlans.length > 0) {
                removedPlans.map((removedPlan) => {
                    API.updateSubscriberPackage({
                        Subscriber_id: res.data._id.toString(),
                        Package_id: removedPlan._id.toString(),
                        PackStartDate: removedPlan.StartDate,
                        Event: utility.getKeyByValue(SUBSCRIPTION_HISTORY_EVENT, SUBSCRIPTION_HISTORY_EVENT.Deleted),
                        DeletedPlan: removedPlan
                    })
                })
            } else {
                //UPDATE SUBSCRIBER HISTORY
                dataItem.PaymentPlan.filter((y) => y.new).map((x) => {
                    API.updateSubscriberPackage({
                        Subscriber_id: res.data._id.toString(),
                        Package_id: x._id,
                        PackStartDate: x.StartDate,
                        Event: utility.getKeyByValue(SUBSCRIPTION_HISTORY_EVENT, SUBSCRIPTION_HISTORY_EVENT.Added)
                    })
                })
            }
            utility.deleteLocalStorageItem(ENTITYNAME.Subscriber);
            cancelEdit();
            refresh();
        } else {
            if (res.code = 413) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Mobile Number already registered in system.' });
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });

            }

        }
    }

    const handleCouponData = (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, gridData, "Name")
        setGridData([...gridData, ...newData]);
    }

    const removeCoupon = (item) => {
        setGridData(gridData.filter((x) => x._id != item._id));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.delete_successfully_grid_data_success_toast_message}` });
    }

    const removePlan = (item) => {

        if (!item.dataItem.new) {
            setRemovedPlans([...removedPlans, item.dataItem]);
        }

        let temp = [...dataItem.PaymentPlan]
        temp.splice(item.dataIndex, 1)
        setDataItem({ ...dataItem, PaymentPlan: temp });
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.delete_successfully_grid_data_success_toast_message}` });
    }

    const MyPaymentPlanCommandCell = (props) => (
        <div className="mt-1" style={{ display: "flex" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removePlan(props), () => { })} />
        </div>
    )

    const MyCouponCommandCell = (props) => (
        <div className="mt-1" style={{ display: "flex" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeCoupon(props.dataItem), () => { })} />
        </div>
    )

    const handleAddPackage = (dataList) => {
        if (dataList.length > 0) {
            setShowPackageStartDatePopup(true);
            if (dataItem.PaymentPlan.length > 0) {
                setPackageData({
                    ...dataList[0],
                    StartDate: moment(new Date(dataItem.PaymentPlan[dataItem.PaymentPlan.length - 1].ExpiryDate)).format('YYYY-MM-DD HH:mm:ss')
                })
            } else {
                setPackageData({
                    ...dataList[0],
                    StartDate: packageData.StartDate
                })
            }
        }
    }

    const onSetPackageData = () => {

        console.log(packageData);
        // i have date "2022-01-01 00:00:00" add current time 
        let startDateInMillis = utility.addCurrentTimeToDate(packageData.StartDate).valueOf();
        let currentDateInMillis = utility.addCurrentTimeToDate(new Date()).valueOf();

        //LESS THAN CURRENT DATE VALIDATION
        // if (startDateInMillis < currentDateInMillis) {
        //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Please enter start date greater than current date` });
        //     return;
        // }

        //VALIDATION FOR OVERLAPPING DATE
        if (dataItem.PaymentPlan.length > 0) {
            let isStartDateOverlapping = dataItem.PaymentPlan.some((x) => x.ExpiryDate > startDateInMillis);
            if (isStartDateOverlapping) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please enter start date greater than expiry date of existing plans" });
                return;
            }
        }

        if (Object.keys(packageData).length > 0) {
            let newData = utility.checkDuplicateInData([packageData], dataItem.PaymentPlan, "Description");
            let expiryDate = moment(packageData.StartDate).add(packageData.OttPeriod.Days, "d").format("YYYY-MM-DD");
            let expiryDateInMillis = utility.addCurrentTimeToDate(expiryDate).valueOf();

            setDataItem({
                ...dataItem,
                PaymentPlan: [...dataItem.PaymentPlan,
                ...newData.map((x) => {
                    return {
                        _id: x._id,
                        Description: x.Description,
                        Amount: x.Amount,
                        StartDate: startDateInMillis,
                        ExpiryDate: expiryDateInMillis,
                        Status: (currentDateInMillis >= startDateInMillis && currentDateInMillis <= expiryDateInMillis) ? 'Active' : 'Deactive',
                        MaxDevices: x?.MaxDevices,
                        deviceLimit: x?.deviceLimit,
                        new: true
                    }
                })]
            });
        }
        setShowPackageStartDatePopup(false);
    }

    const Mystatuscell = (props) => {

        let tileBackColor = props.dataItem[props.field] == 'Active' ? "#63aa43" : "#E72929";

        if (props.field == 'Event') {
            tileBackColor = "#006769"
        }

        return <MyStatusCell title={props.dataItem[props.field]} tileBackColor={tileBackColor} />

    }

    const deleteSelectedDevice = (index) => {
        let removeData = [...devicesData.slice(0, index), ...devicesData.slice(index + 1, devicesData.length)]
        setDevicesData(removeData);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${lang.delete_successfully_grid_data_success_toast_message}` });
    }

    const MyDeviceCommandCell = (cell) => {
        return <td>
            <RoundButton icon="trash" Title={lang.delete_button_tooltip} onClick={() => ConfirmDeleteAlert(() => deleteSelectedDevice(cell.dataIndex), () => { })} />
        </td>
    }

    const handleProfileData = (dataList) => {
        if (profileData.length > 0) {
            const isDuplicate = profileData.some((x, index) => x?.Description === dataList?.Description && index !== dataList?.index);
            if (isDuplicate) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.already_exists_global_error_message });
                return;
            }
        }
        setProfileData((prevGridData) => {
            let updatedData = [...prevGridData];
            if (dataList?.index !== undefined && dataList?.index !== null) {
                updatedData[dataList.index] = { ...updatedData[dataList.index], ...dataList };
            } else { updatedData.push(dataList); }
            return updatedData;
        });
    };

    const deleteProfileValue = (index, dataItem) => {
        setdeleteItemsProfile([...deleteItemsProfile, dataItem]);
        let removeData = [...profileData.slice(0, index), ...profileData.slice(index + 1, profileData.length)]
        setProfileData(removeData);
    }

    const editProfileValue = (item) => {
        setSelectedItemRef(item);
        setShowSubscriberProfileForm(true);
    };

    const MyProfileCommandCell = (cell) => {
        return <td>
            <RoundButton icon="trash" Title={lang.delete_button_tooltip} onClick={() => ConfirmDeleteAlert(() => deleteProfileValue(cell.dataIndex, cell.dataItem), () => { })} />
            <RoundButton icon="pencil" Title={lang.edit_button_tooltip} onClick={() => editProfileValue({ ...cell.dataItem, index: cell.dataIndex })} />
        </td>
    }


    return (
        <>
            <BossDialog
                title={item.Name ?? `${lang.create_subscriber_dialog_header}`}
                onClose={cancelEdit}
                width={"900px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={cancelEdit} showTitle={false} showStatusCell={true} status={item.Status} statusCellColor={item.Status == 'Active' ? 'green' : 'red'} />
                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className='col-6'>
                                <label>{lang.subscription_id_label} *</label>
                                <input
                                    name={"SubscriptionID"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem?.SubscriptionID}
                                    disabled={item?.SID > 0}
                                />
                            </div>
                            <div className='col-6'>
                                <label>{lang.name_label} *</label>
                                <input
                                    name={"Name"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem?.Name}
                                />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className='col-6'>
                                <label>{lang.rmn_label} *</label>
                                <input
                                    name={"RMN"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem?.RMN}
                                />
                            </div>
                            <div className='col-6'>
                                <label>{lang.email_label} *</label>
                                <input
                                    name={"Email"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChange}
                                    value={dataItem?.Email}
                                />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-3' style={{ paddingRight: "5px" }}>
                                <label>{lang.region_label} *</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ background: "white" }}
                                    data={regions}
                                    name="Region"
                                    textField='Description'
                                    dataItemKey='_id'
                                    value={dataItem?.Region}
                                    onChange={onChange}
                                />
                            </div>
                            <div className='col-3' style={{ paddingLeft: "5px" }}>
                                <label htmlFor="TabView">{lang.segment_label}</label>
                                <MultiSelect
                                    style={{ backgroundColor: "white" }}
                                    data={segments}
                                    name="Segments"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem?.Segments}
                                    onChange={onChange}
                                />
                            </div>
                            <div className='col-6'>
                                <label>{lang.currency_label}</label>
                                <DropDownList
                                    className="form-control form-control-sm"
                                    style={{ background: "white" }}
                                    data={currencys}
                                    name="Currency"
                                    textField='Description'
                                    dataItemKey='_id'
                                    value={dataItem?.Currency}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col mt-3">
                                <Field
                                    name={"AutoRenew"}
                                    component={Switch}
                                    label={lang.auto_renew_subscription_label}
                                    onLabel={lang.auto_renew_subscription_label}
                                    offLabel={lang.auto_renew_subscription_label}
                                    size={"medium"}
                                    onChange={(e) => onChange(e)}
                                    checked={dataItem?.AutoRenew}
                                />
                                <label htmlFor="TabView">{lang.auto_renew_subscription_label}</label>
                                <Switch
                                    name="EnableParentalControl"
                                    className='ml-3'
                                    label={lang.parental_control_label}
                                    onChange={onChange}
                                    checked={dataItem?.EnableParentalControl}
                                    value={dataItem?.EnableParentalControl}
                                    size={"medium"}
                                />
                                <label>{lang.parental_control_label}</label>
                            </div>
                            <div className='col-6 ml-2' style={{ marginTop: "24px" }}>
                                <Field
                                    style={{ borderColor: "black" }}
                                    name={"Archive"}
                                    component={Checkbox}
                                    label={lang.archive}
                                    onChange={onChange}
                                />
                            </div>
                        </div>

                        <div className="row" style={{ margin: "0px" }}>
                            <Box sx={{ width: '100%', typography: 'body1' }}>
                                <TabContext value={tabNumber}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                            <Tab label={lang.payment_plan_label} value="1" />
                                            <Tab label={lang.coupon_label} value="2" />
                                            <Tab label={lang.subscriber_subscription_history} value="3" />
                                            <Tab label={lang.subscriber_login_history} value="4" />
                                            <Tab label={lang.devices_label} value="5" />
                                            <Tab label={lang.profile_label} value="6" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value={"1"} style={{ padding: '10px' }}>
                                        <div className="row">
                                            <div className="col-8">
                                                <AddRoundButton onClick={() => setShowPackageCollection(true)} title={'Add Payment Plan'} />
                                            </div>
                                            <div className="col-4">
                                                <h5 className="pull-right">{lang.payment_plan_label}</h5>
                                            </div>
                                        </div>
                                        <Grid data={dataItem?.PaymentPlan} style={{ height: '180px', margin: '5px 0px' }}>
                                            <GridColumn cell={MyPaymentPlanCommandCell} width={"40px"} locked={true} />
                                            <GridColumn field="Description" title={lang.description_column} />
                                            <GridColumn field="Amount" title={lang.amount_column} />
                                            <GridColumn field="StartDate" title={"Start Date"} cell={DateOnlyCell} />
                                            <GridColumn field="ExpiryDate" title={"Expiry Date"} cell={DateOnlyCell} />
                                            <GridColumn field="Status" title={"Status"} cell={Mystatuscell} />
                                            <GridColumn field="deviceLimit" title={"Device Limit"} />
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={"2"} style={{ padding: '10px' }}>
                                        <div className="row">
                                            <div className="col-8">
                                                <AddRoundButton onClick={() => setShowCoupon(true)} title={lang.add_coupon_tooltip} />
                                            </div>
                                            <div className="col-4">
                                                <h5 className="pull-right">{lang.coupon_label}</h5>
                                            </div>
                                        </div>
                                        <Grid data={gridData} style={{ height: '180px', margin: '5px 0px' }}>
                                            <GridColumn cell={MyCouponCommandCell} width={"35px"} locked={true} />
                                            <GridColumn field="Name" title={lang.name_column} editable={false} />
                                            <GridColumn field="Code" title={lang.code_column} editable={false} />
                                            <GridColumn field="DiscountType.Type" title={lang.discount_type_column} editable={false} />
                                            <GridColumn field="DiscountValue" title={lang.discount_value_column} editable={false} />
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={"3"} style={{ padding: '5px' }}>
                                        <div className="row">
                                            <div className="col-8">
                                            </div>
                                            <div className="col-4">
                                                <h5 className="pull-right">{lang.subscriber_subscription_history}</h5>
                                            </div>
                                        </div>
                                        <Grid data={historyData} style={{ height: '180px', margin: '5px 0px' }}>
                                            <GridColumn field="timeStramp" title={"Timestamp"} cell={DateTimeCell} editable={false} width={180} />
                                            <GridColumn field="selectedPlan.Description" title={"Plan"} editable={false} width={180} />
                                            <GridColumn field="Event" title={"Event"} cell={Mystatuscell} editable={false} width={180} />
                                            <GridColumn field="selectedPlan.StartDate" title={"StartDate"} cell={DateOnlyCell} editable={false} width={140} />
                                            <GridColumn field="selectedPlan.ExpiryDate" title={"Expiry Date"} cell={DateOnlyCell} editable={false} width={140} />
                                            {/* <GridColumn field="Status" title={"Status"} cell={Mystatuscell} editable={false} width={100} />
                                                        <GridColumn field="selectedPlan.Amount" title={'Plan Amount'} editable={false} width={100} />
                                                        <GridColumn field="orderId" title={"Order Id"} editable={false} width={120} />
                                                        <GridColumn field="paymentId" title={"Payment Id"} editable={false} width={120} /> */}
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={"4"} style={{ padding: '5px' }}>
                                        <div className="row">
                                            <div className="col-8">
                                            </div>
                                            <div className="col-4">
                                                <h5 className="pull-right">{lang.subscriber_login_history}</h5>
                                            </div>
                                        </div>
                                        <Grid data={loginHistoryData} style={{ height: '180px', margin: '5px 0px' }}>
                                            <GridColumn field="timeStramp" title={"Last Login"} cell={DateTimeCell} editable={false} />
                                            <GridColumn field="Platform" title={lang.platform_label} editable={false} />
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={"5"} style={{ padding: '5px' }}>
                                        <div className="row">
                                            <div className="col-12">
                                                <h5 className="pull-right">{lang.devices_label}</h5>
                                            </div>
                                        </div>
                                        <Grid data={devicesData} style={{ height: '180px', margin: '5px 0px' }}>
                                            <GridColumn editable={false} cell={MyDeviceCommandCell} width={"60px"} />
                                            <GridColumn field="serialNumber" title={lang.serial_number_column} editable={false} />
                                            <GridColumn field="deviceName" title={lang.device_name_column} editable={false} />
                                            <GridColumn field="lastLoginTime" title={lang.last_login_time_column} cell={DateTimeCell} editable={false} />
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={"6"} style={{ padding: '10px' }}>
                                        <div className="row">
                                            <div className="col-8">
                                                <AddRoundButton onClick={() => { setShowSubscriberProfileForm(true); setSelectedItemRef({}) }} title={'Profile'} />
                                            </div>
                                            <div className="col-4">
                                                <h5 className="pull-right">{lang.profile_label}</h5>
                                            </div>
                                        </div>
                                        <Grid data={profileData} style={{ height: '180px', margin: '5px 0px' }}>
                                            <GridColumn cell={MyProfileCommandCell} width={"100px"} locked={true} />
                                            <GridColumn field="Description" title={lang.description_column} editable={false} />
                                            <GridColumn field="EnablePgRestriction" title={lang.enable_pg_restriction_label} editable={false} />
                                            <GridColumn field="Restricted_PgRatings" title={lang.restricted_pgratings_label} editable={false} />
                                            <GridColumn field="EnableParentalControl" title={lang.enable_parent_control_label} editable={false} />
                                        </Grid>
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </div>
                        {showCoupon && <CollectionSelection entityname={ENTITYNAME.Coupon} title={lang.select_coupon_collection} closeForm={() => setShowCoupon(false)} setDataList={handleCouponData} width={"50vw"} />}
                        {showPackageCollection && <CollectionSelection title={lang.select_package_header} setDataList={handleAddPackage} entityname={ENTITYNAME.PaymentPlan} closeForm={() => setShowPackageCollection(false)} mode={'single'} width={"50vw"} />}
                        {showPackageStartDatePopup && <BossDialog
                            title={'Plan Start Date'}
                            onClose={() => setShowPackageStartDatePopup(false)}
                            width={"300px"}
                        >
                            <EditPageHeader title={""} onSubmit={onSetPackageData} onCancel={() => setShowPackageStartDatePopup(false)} showTitle={false} />
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <label>{lang.start_date_label} *</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        name="StartDate"
                                        value={packageData.StartDate}
                                        onChange={(e) => {
                                            setPackageData({
                                                ...packageData,
                                                StartDate: e.target.value
                                            })
                                        }}
                                        min={moment(new Date()).format('YYYY-MM-DD')}
                                    />
                                </div>
                            </div>
                        </BossDialog >}
                        {showSubscriberProfileForm && <SubscriberProfileEditForm data={selectedItemRef.current} onClose={() => setShowSubscriberProfileForm(false)} handleProfileData={handleProfileData} />}
                    </div>
                </div>
            </BossDialog >
        </>
    )
}

export default SubscriberEditForm;